import React, { PureComponent } from 'react';
import { Table, Button, InputGroup, InputGroupAddon, Input, Label } from 'reactstrap';

import PropTypes from 'prop-types';
import { slugify } from 'transliteration';
import { Blogs } from '../../../services/Blogs';
import withErrorNotification from '../../../hof/withErrorNotification';
import { categoryAdd, categoryDelete, categoryUpdate } from '../../../redux/actions/blogsActions';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip'
import DeleteForeverIcon from 'mdi-react/DeleteForeverIcon';
import {withTranslation} from "react-i18next";

const slugifyOptions = {
  lowercase: true,
  trim: true
}

class BlogCategories extends PureComponent {
  static propTypes = {
    blog: PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      category_name: '',
      category_id: null
    };
  }

  handleCategorySelect = (category) => {
    this.setState({
      category_id: category._id,
      category_name: category.name
    });
  }

  handleClick = async (e) => {
    e.preventDefault();

    const { category_name, category_id } = this.state;

    if (category_name && category_name !== "") {
      if (!category_id) {
        await this.handleCategoryCreate(category_name);
      } else {
        await this.handleCategoryUpdate(category_id, category_name, slugify(category_name, slugifyOptions));
      }
    }
  };

  handleCategoryUpdate = async (id, name, slug) => {
    await withErrorNotification(async () => {
      const { category } = await Blogs.updateCategory(id, name, slug);
      console.log(category);
      this.props.onCategoryUpdate(category);
      this.setState({ category_name: "", category_id: null });
    });
  }

  handleCategoryCreate = async (name) => {
    await withErrorNotification(async () => {
      const { category } = await Blogs.addCategory(this.props.blog._id, name, slugify(name, slugifyOptions));
      console.log(category);
      this.props.onCategoryAdd(category);
      this.setState({ category_name: "", category_id: null });
    });
  }

  handleCategoryDelete = async (category) => {
    await withErrorNotification(async () => {
      await Blogs.deleteCategory(category._id);
      this.props.onCategoryDelete(category._id);
      console.log("deleted", category._id)
    })
  }

  render() {
    const { blog, t } = this.props;

    return (
      <>
        <ReactTooltip place="right" type="info" effect="solid" />

        <Table striped hover responsive className="table--bordered cart__table">
          <tbody>
            {blog.categories && blog.categories.map(category => {
              return (
                <tr key={category._id} data-tip={t('settings.categories.tooltips.click_to_edit')} data-delay-show='500'>

                  <td onClick={() => this.handleCategorySelect(category)}>
                    <span>{category.name}</span>
                  </td>

                  <td style={{ width: "15%" }} >
                    <button className="cart__table-btn" type="button" onClick={() => this.handleCategoryDelete(category)}>
                      <DeleteForeverIcon /> {t('settings.categories.button_remove')}
                    </button>
                  </td>
                </tr>
              )
            })}
            {(!blog.categories || blog.categories.length === 0) && <tr><td><p>{t('settings.categories.your_dont_have_any_categories_yet')}</p></td></tr>}
          </tbody>
        </Table>
        <br />

        <form className="form form--vertical" onSubmit={this.handleClick}>
          <Label for="category">{this.state.category_id ? t('settings.categories.update_category') : t('settings.categories.create_new_cateogory')}</Label>
          <InputGroup className="form__form-group-field">
            <Input
              placeholder={t('settings.categories.placeholder')}
              type="text"
              name="category"
              className="blog-categories-input"
              value={this.state.category_name}
              onChange={(event) => { this.setState({ category_name: event.target.value }) }}
            />
            <InputGroupAddon addonType="append">
              <Button
                className={`form__form-group-button`}
                color="success"
                size="sm"
                onClick={this.handleClick}
              >{this.state.category_id ? t('settings.categories.button_update') : t('settings.categories.button_add_new')}</Button>
            </InputGroupAddon>
          </InputGroup>
        </form>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCategoryAdd: (category) => { dispatch(categoryAdd(category)) },
    onCategoryUpdate: (category) => { dispatch(categoryUpdate(category)) },
    onCategoryDelete: (id) => { dispatch(categoryDelete(id)) }
  }
}

export default connect(null, mapDispatchToProps)(withTranslation('dashboard')(BlogCategories))
